import axios from '@/lib/axios';

const signOut = () => {
  return axios.delete("facility/sign_out");
}

export default signOut;